import { Link } from "react-router-dom";
import {styled} from "styled-components";

export const Container = styled.div`
    max-width: 1200px;
    background: white;
`;


export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
`;

export const Title = styled.h1`
    font-size: 20px;
    font-weight: 600;
    margin: 0;

`;

export const AddButton = styled.button`
    background: rgb(77, 105, 156);

    color: white;
    border: none;
    border-radius: 6px;
    padding: 1px 22px;
    font-size: 14px;
    display: flex;
    font-weight: 600;
    align-items: center;
    gap: 10px;
    cursor: pointer;

    &:hover {
        background: rgb(67, 91, 136);
    }
`;

export const StepsTable = styled.div`
  width: 100%;
  border-spacing: 0;
`;

export const StepHeader = styled.div`
  display: grid;
  grid-template-columns: 315px 235px 1fr 140px;
  gap: 16px;
  padding: 12px 0;
  align-items: start;
  font-weight: 400;
  font-size: 14px;
  background: rgb(246, 243, 243);
  border-radius: 6px;
`;

export const Th = styled.th`
    padding: 0 5px 0 15px;
    background: rgb(245, 245, 245);
    font-size: 14px;
    text-align: left;
    font-weight: normal;


    // Первая колонка (Наименование)

    &:nth-child(1) {
        width: 45%;
    }

    // Вторая колонка (Бот в телеграме)

    &:nth-child(2) {
        width: 31%;
    }

    // Третья колонка (Файлы и данные)

    &:nth-child(3) {
        width: 30%;
    }

    // Четвертая колонка (Дата создания)

    &:nth-child(4) {
        width: 10%;
    }

    @media (max-width: 768px) {
        &:nth-child(1) {
            width: 40%;
        }

        &:nth-child(2) {
            width: 25%;
        }

        &:nth-child(3) {
            width: 20%;
        }

        &:nth-child(4) {
            width: 15%;
        }
    }
`;

export const StepRow = styled.div`
  display: grid;
 grid-template-columns: 315px 235px 1fr 140px;
  gap: 16px;
  padding: 19px 0;
  align-items: start;
  font-weight: 400;
  font-size: 14px;
  border-bottom: 1px solid rgb(232, 232, 232);
  
`;

export const Td = styled.td`
    padding: 20px;
    font-size: 14px;
    border-bottom: 1px solid #eee;


    tr:last-child & {
        border-bottom: none;
    }
`;

export const AssistantName = styled(Link)`
    display: flex;
    align-items: center;
    gap: 12px;

    img {
        width: 24px;
        height: 24px;
        border-radius: 50%;
    }
`;

export const BotName = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    color: #666;

    img {
        width: 16px;
        height: 16px;
    }
`;

export const Records = styled(Link)`
    color: rgb(35, 88, 162);
    margin-left: 24px;
`;


export const StyledSpan = styled.span`
`;
